import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

/**
 * Toast Controller
 * 
 * Manages Bootstrap toast notifications.
 * Automatically shows toasts on connect and disposes of them on disconnect.
 * 
 * Features:
 * - Automatically shows toast notifications on connect
 * - Properly disposes of toast instances on disconnect
 * - Prevents memory leaks from toast instances
 * 
 * Usage: Add data-controller="toast" to toast notification elements
 */
export default class extends Controller {
  connect() {
    const delay = this.element.getAttribute('data-bs-delay') || 8000
    this.toast = new bootstrap.Toast(this.element, {
      autohide: true,
      delay: parseInt(delay, 10)
    })
    // Remove 'show' class if present, then call show() to properly start the timer
    // Bootstrap needs show() to be called to initialize the auto-hide timer
    if (this.element.classList.contains('show')) {
      this.element.classList.remove('show')
    }
    // Call show() which will add the 'show' class and start the auto-hide timer
    this.toast.show()
  }

  disconnect() {
    // Intentionally do NOT call this.toast.dispose() here.
    // There is a known Bootstrap bug where disposing a toast while a
    // transition is in progress can cause "null is not an object
    // (evaluating 'this._element.classList')" errors from inside
    // Bootstrap's internal transition handlers.
    //
    // Stimulus will tear down this controller instance when the element
    // is removed, and the toast instance will be garbage-collected with it,
    // so an explicit dispose is not required for correctness here.
  }
} 